/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API SSO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AccessAwardDto } from '../models';
// @ts-ignore
import type { AwardDto } from '../models';
/**
 * AWARDSApi - axios parameter creator
 * @export
 */
export const AWARDSApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AccessAwardDto} accessAwardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardControllerAddAccessRight: async (accessAwardDto: AccessAwardDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessAwardDto' is not null or undefined
            assertParamExists('awardControllerAddAccessRight', 'accessAwardDto', accessAwardDto)
            const localVarPath = `/awards/addAccessRight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessAwardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AwardDto} awardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardControllerAddCredits: async (awardDto: AwardDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'awardDto' is not null or undefined
            assertParamExists('awardControllerAddCredits', 'awardDto', awardDto)
            const localVarPath = `/awards/addCredits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(awardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AWARDSApi - functional programming interface
 * @export
 */
export const AWARDSApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AWARDSApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AccessAwardDto} accessAwardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async awardControllerAddAccessRight(accessAwardDto: AccessAwardDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.awardControllerAddAccessRight(accessAwardDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AWARDSApi.awardControllerAddAccessRight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AwardDto} awardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async awardControllerAddCredits(awardDto: AwardDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.awardControllerAddCredits(awardDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AWARDSApi.awardControllerAddCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AWARDSApi - factory interface
 * @export
 */
export const AWARDSApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AWARDSApiFp(configuration)
    return {
        /**
         * 
         * @param {AccessAwardDto} accessAwardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardControllerAddAccessRight(accessAwardDto: AccessAwardDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.awardControllerAddAccessRight(accessAwardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AwardDto} awardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardControllerAddCredits(awardDto: AwardDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.awardControllerAddCredits(awardDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AWARDSApi - object-oriented interface
 * @export
 * @class AWARDSApi
 * @extends {BaseAPI}
 */
export class AWARDSApi extends BaseAPI {
    /**
     * 
     * @param {AccessAwardDto} accessAwardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AWARDSApi
     */
    public awardControllerAddAccessRight(accessAwardDto: AccessAwardDto, options?: RawAxiosRequestConfig) {
        return AWARDSApiFp(this.configuration).awardControllerAddAccessRight(accessAwardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AwardDto} awardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AWARDSApi
     */
    public awardControllerAddCredits(awardDto: AwardDto, options?: RawAxiosRequestConfig) {
        return AWARDSApiFp(this.configuration).awardControllerAddCredits(awardDto, options).then((request) => request(this.axios, this.basePath));
    }
}

